import type { FilesRailFileMenuActions } from "@/layouts/WorkspaceLayout/components/WorkspaceLeftRail/rail/files/FilesRailFileRow";
import { useFileRecordCardActions } from "@/pages/workspaces/hooks/useFileRecordCardActions";
import type { FileRecord } from "@cohesive/api-client";
import { useMemo } from "react";

type UseFilesRailContextFileActionsParams = {
  allRecords: FileRecord[];
  /** When set, placed canvas files have their node removed with the delete. */
  fileRecordIdToNodeId?: Map<string, string>;
};

/** Menu actions + dialogs for canvas / flow-session file rows in the Files rail context section. */
export function useFilesRailContextFileActions({
  allRecords,
  fileRecordIdToNodeId,
}: UseFilesRailContextFileActionsParams) {
  const { dialogs: baseDialogs, actions } = useFileRecordCardActions({
    allRecords,
    onFolderOpen: () => {},
    fileRecordIdToNodeId,
  });

  const menuActions = useMemo(
    (): FilesRailFileMenuActions => ({
      onRename: actions.rename,
      onDelete: actions.delete,
      onCopy: actions.copy,
    }),
    [actions.rename, actions.copy, actions.delete],
  );

  return { menuActions, dialogs: baseDialogs };
}
